// extracted by mini-css-extract-plugin
export default {"tabletImg":"cP","desktopImg":"eP","mobileImg":"fP","backgroundImage":"gP","content":"hP","rtbLeft":"iP","rtbRight":"jP","imageContainer":"kP","rtbBox":"lP","line":"mP"};
    if(module.hot) {
      // 1737143662628
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  